// src/components/OrgInstallDisplay.js
import React from "react";
import logger from "../utils/logger";
import "./OrgInstallDisplay.css";

/**
 * Component to display current organization and installation context
 */
function OrgInstallDisplay({
  organizationId,
  organizationName,
  installationId,
  installationName,
}) {
  const handleCopy = (text, label) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        logger.log(`${label} copied to clipboard: ${text}`);
      })
      .catch((err) => {
        logger.error("Failed to copy:", err);
      });
  };

  return (
    <div className="org-install-display">
      <div className="org-install-item">
        <div className="org-install-content">
          <span className="org-install-label">Organization:</span>
          <span className="org-install-value">{organizationName}</span>
        </div>
        <div className="org-install-id-row">
          <span className="org-install-id">({organizationId})</span>
          <button
            className="copy-icon-button"
            onClick={() => handleCopy(organizationId, "Organization ID")}
            title="Copy Organization ID"
          >
            📋
          </button>
        </div>
      </div>
      <div className="org-install-divider">|</div>
      <div className="org-install-item">
        <div className="org-install-content">
          <span className="org-install-label">Site:</span>
          <span className="org-install-value">{installationName}</span>
        </div>
        <div className="org-install-id-row">
          <span className="org-install-id">({installationId})</span>
          <button
            className="copy-icon-button"
            onClick={() => handleCopy(installationId, "Site ID")}
            title="Copy Site ID"
          >
            📋
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrgInstallDisplay;
